import { render, staticRenderFns } from "./myIntegral.vue?vue&type=template&id=71535fec&scoped=true&"
import script from "./myIntegral.vue?vue&type=script&lang=js&"
export * from "./myIntegral.vue?vue&type=script&lang=js&"
import style0 from "./myIntegral.vue?vue&type=style&index=0&id=71535fec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71535fec",
  null
  
)

export default component.exports